import { useAuth } from '@features/auth/hooks/useAuth';

/*
    ____,-------------------------------,____
    \   |            Toggles            |   /
    /___|-------------------------------|___\
*/

const ToggleList = [
  // Раздел со студией (для создания уроков)
  { name: 'studio', enabled: true, userClubs: ['200'] },
  // Видеоконтроль в настройках турнира
  { name: 'tournamentVideo', enabled: true, clubs: ['777', '1001', '200', '201'] },
] as const satisfies readonly IToggle[];

/*
    ____,-------------------------------,____
    \   |             Types             |   /
    /___|-------------------------------|___\
*/

type IFeatures = (typeof ToggleList)[number]['name'];
type IToggle = {
  name: string;
  enabled: boolean;
  userIds?: readonly string[];
  userClubs?: readonly string[];
  clubs?: readonly string[];
  env?: 'production' | 'staging' | 'development';
};
type IRegistry = { [name in IFeatures]: IToggle };

/*
    ____,-------------------------------,____
    \   |             Registry          |   /
    /___|-------------------------------|___\
*/

const ToggleRegistry: IRegistry = ToggleList.reduce((sink, toggle) => {
  sink[toggle.name] = toggle;
  return sink;
}, {} as IRegistry);

/*
    ____,-------------------------------,____
    \   |             Hook              |   /
    /___|-------------------------------|___\
*/

export function useIsFeatureEnabled(feature: IFeatures, clubId?: string) {
  const toggle = ToggleRegistry[feature];
  const needUserId = !!toggle.userIds?.length;
  const needUserClubs = !!toggle.userClubs?.length;
  const needClub = !!toggle.clubs?.length;

  const { user } = useAuth();

  if (needClub && !clubId) {
    throw new Error(`useIsFeatureEnabled: clubId is required for feature "${feature}"`);
  }

  return Boolean(
    // enabled?
    toggle.enabled &&
    // correct env?
    (!toggle.env || toggle.env === __RUNTIME.mode) &&
    // correct user?
    (!needUserId || (user && toggle.userIds?.includes(user.userId))) &&
    // correct user club?
    (!needUserClubs || (user && toggle.userClubs?.some((id) => user.clubs[id]))) &&
    // correct club?
    (!needClub || (clubId && toggle.clubs?.includes(clubId))),
  );
}
